export enum RecoverPasswordState {
  waitingEmailForSentCode,
  resetCodeRequested,
  checkMailForCode,
  passwordChanged,
  checkSMSForCode,
}
